import styled from 'styled-components';


export const Content = styled.div`
  display:flex;
  flex-direction: column;
  margin: 2rem 0;

  label{
    font-weight: 700;
  }

  textarea{
    resize: none;
    background: #f6f6f6;
    border: 1px solid #f6f6f6;
    padding: 1rem;
    font-weight: normal;
    color: #666360;
  }
`;
